export interface ISidenavMenu {
    icon?: string,
    title?: string,
    count?: number,
    type?: ESlidenavMenu,
    active?: boolean;
    link?: string;
    query?: SidenavMenuQuery,
    children?: ISidenavMenu[];
    expanded?: boolean;
}

export class SidenavMenuQuery {
    [key: string]: any;
}

export enum ESlidenavMenu {
    LIBRARY = 1,
    ADDED_BOOKS,
    CLUBS,
    REVIEWS,
    POSTS,
    BOOK_LISTS,
    CHALLENGES,
    BOOKMARKS,
    SETTING,
    GUID,
    SUPPORT,
    PROFILE,
    NOTIFICATION,
    MESSAGES,
    HOME,
    EXPLORE,
    More
}